module.exports = __webpack_public_path__ + "img/49.d914af8c.jpg";